import request from 'api/request';

export default function courseStaffIndexRoute(courseId) {
  return request({ url: `/courses/${courseId}/staff` });
}
